import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  InputAdornment,
  RadioGroup,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Alert,
  Dialog,
  DialogContent,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CANADAflag from "../../assets/Images/canada.png";
import usflag from "../../assets/Images/us.png";
import dayjs from "dayjs";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Field from "../../components/Field";
import CoTextField from "../../components/CoTextField";
import CoDatePicker from "../../components/CoDatePicker";
import CoDropdown from "../../components/CoDropdown/CoDropdown";
import {
  alphaNumeric,
  decimalValue,
  formatCurrency,
  number,
  onlyAlphabetWithSpace,
} from "../../utils/normalizers";
import useAuth from "../../hooks/useAuth";
import { useSelector } from "react-redux";
import { calculateData } from "../../services/apiRequests";
import { sortGroupedLookups } from "../../utils/helpers";

const API_BASE_URL = process.env.REACT_APP_SERVICES_BASE_URL; 

const useStyles = makeStyles(() => ({
  usFlag: {
    width: "40px",
    height: "24px",
    background: `url(${usflag})`,
    backgroundColor: "lightgray",
    backgroundPosition: "-2.977px -4.849px",
    backgroundSize: "112.59% 140.42%",
    backgroundRepeat: "no-repeat",
  },
  CANADAflag: {
    width: "40px",
    height: "24px",
    background: `url(${CANADAflag})`,
    backgroundColor: "lightgray",
    backgroundPosition: "-2.977px -4.849px",
    backgroundSize: "112.59% 140.42%",
    backgroundRepeat: "no-repeat",
  },
}));

const QuickCalcv2NoTransfer = () => {
  const classes = useStyles();
  const candidateList = useSelector((state) => state.dropedField ?? {});
  const loginData = candidateList?.loginData ?? {};

  // Form Data State
  const [alignment, setAlignment] = useState("USA");

  // Dropdown Options State
  const [lookupData, setLookupData] = useState({
    countries: [],
    businessUnits: [],
    resourceTypes: [],
    states: [],
    provinces: [],
    insuranceTypes: [],
    immigrationTypes: [],
    yesNo: [],
  });

  const [vmsFeeOptions, setVmsFeeOptions] = useState([]);
  const [calculationResult, setCalculationResult] = useState(null);
  const [calculatedOnce, setCalculatedOnce] = useState(false);
  const [holidayToggle, setHoliddayToggle] = useState(false);
  const [holidayDataToggle, setHolidayDataTggle] = useState({});
  // UI State
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { getAccess } = useAuth();
    const { noAccess: totalComoer24 } = getAccess("10");
    const { noAccess: reMntlyCmsPH } = getAccess("11");
    const { noAccess: tcmnsPH } = getAccess("12");
    const { noAccess: hrlyRate } = getAccess("13");
    const { noAccess: Boarding } = getAccess("15");
    const { noAccess: termination } = getAccess("16");
    const { noAccess: calcCountry } = getAccess("17");

  const visibleAccess = {
      recuiterMonthlyCommissionPerHour: totalComoer24,
      totalCommissionForMonthPro: reMntlyCmsPH,
      recruiterMonthlyCommissionPro: tcmnsPH,
      hourlyRate: hrlyRate,
      onboardingDt: Boarding,
      terminationDt: termination,
      calculationCountry: calcCountry,
  };

 
   const userSchema = yup.object({
      candidateBillRate: yup.string().required("Enter Bill Rate"),
      payRate: yup.string().required("Enter Pay Rate"),
      // candidateCountry: yup.string().required("Select Working Location"),
      // calculationCountry: yup.string().required("Select Calculation Location"),
      // candidateBusinessUnit: yup.string().required("Select Business Unit"),
      // candidateTypeOfResource: yup.string().required("Select Resource Type"),
      // vmsFee: yup.string().required("Select VMS Fee"),
      // sickLeaveNoOfDays: yup.string().when("candidateTypeOfResource", {
      //   is: (type) => type !== "C2C",
      //   then: (schema) => schema.required("Enter Sick Leave Days"),
      // }),
      // refferalAmount: yup.string().when("candidateTypeOfResource", {
      //   is: (type) => type !== "C2C",
      //   then: (schema) => schema.required("Enter Referral Amount"),
      // }),
      // otherExpenses: yup.string().when("candidateTypeOfResource", {
      //   is: (type) => type !== "C2C",
      //   then: (schema) => schema.required("Enter Other Expenses"),
      // }),
      // candidateInsurenceType: yup
      //   .string()
      //   .when(["candidateTypeOfResource", "candidateCountry"], {
      //     is: (type, country) => country !== "CAD" && type !== "C2C",
      //     then: (schema) => schema.required("Select Insurance Type"),
      //   }),
      // holidays: yup
      //   .string()
      //   .when(["candidateCountry", "candidateTypeOfResource"], {
      //     is: (country, type) => country !== "CAD" && type !== "C2C",
      //     then: (schema) => schema.required("Select Holidays"),
      //   }),
      // immgirationType: yup
      //   .string()
      //   .when(["candidateCountry", "candidateTypeOfResource"], {
      //     is: (country, type) => country !== "CAD" && type !== "C2C",
      //     then: (schema) => schema.required("Enter Immigration Type"),
      //   }),
      // otherExpensesHourly: yup
      //   .string()
      //   .when(["candidateTypeOfResource", "candidateCountry"], {
      //     is: (type, country) => country === "CAD" && type !== "C2C",
      //     then: (schema) => schema.required("Enter Other Expenses Hourly"),
      //   }),
      // vacationNoOfDays: yup
      //   .string()
      //   .when(["candidateCountry", "candidateTypeOfResource"], {
      //     is: (country, type) => country === "CAD" && type !== "C2C",
      //     then: (schema) => schema.required("Enter Vacation Days"),
      //   }),
      statutoryHolidays: yup.number(),
      optionalHolidays: yup.number(),
      perDiemCount: yup.number(),
      jobId: yup.mixed().nullable(),
      totalCommissionFor24Months: yup.mixed().nullable(),
    });
  
    const {
      control,
      watch,
      setValue,
      getValues,
      reset,
      handleSubmit,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(userSchema),
      defaultValues: {
        candidateName: "",
        candidateJobTitle: "",
        jobId: null,
        candidateStartDt: null,
        candidateBillRate: "",
        payRate: "",
        candidateCountry: "USA",
        calculationCountry: "USA",
        candidateBusinessUnit: "",
        candidateTypeOfResource: "W2",
        vmsFee: Number(231),
        sickLeaveNoOfDays: 0,
        refferalAmount: 0,
        otherExpenses: 0,
        candidateInsurenceType: "NON",
        holidays: "NO",
        immgirationType: "NO",
        otherExpensesHourly: 0,
        vacationNoOfDays: 0,
        totalCommissionFor24Months: 24,
        perDiemCount: 0,
        allowedMarkupPct: "",
        provinceState: "",
        statutoryHolidays: 0,
        optionalHolidays: 0,
        tnVisaCountry: "",
        leaveStateCd: "",
        recruiterName: "",
        accountExecutive: "",
        onboardingDt: null,
        terminationDt: null,
        vacationPayHourly: 0,
        vacationPayAnnual: 0,
        recuiterTotCommissionForMonths: "",
        perDiem: "0.00",
        maxPay: "",
        payRatePerDiem: "",
        b2biMargin: "",
        grossMarginPercentage: "",
        grossMarginDollar: "",
        blendedGrossMarginPercentage: "",
        recuiterMonthlyCommission: "",
        recMnthlyCommissionBonus: "",
        recuiterMonthlyCommissionPerHour: "",
        totalCommissionForMonthPro: null,
        recruiterMonthlyCommissionPro: null,
        ttlMonthlyCommissionUSDVal: "",
        recruiterMonthlyCommissionUSDVal: "",
        hourlyRate: "",
        maxMarkup: 0,
      },
    });
  
  const candidateCountry = watch("candidateCountry");
  const candidateTypeOfResource = watch("candidateTypeOfResource");
  const immigration = watch("immgirationType");
  const businessUnit = watch("candidateBusinessUnit");
  const calCountry = watch("calculationCountry");
  const vmsFee = watch("vmsFee");
  const workingLocation = watch("candidateCountry");
  const leaveStateCd = watch("leaveStateCd");

   const setMydivName = (name, divName) => {
    let myDivName = "";
    if (calCountry === "CAD" || candidateCountry === "CAD") {
      switch (name) {
        case "recuiterMonthlyCommission": {
          myDivName = "Recruiter Monthly Commission(CAD)";
          break;
        }
        case "totalCommissionFor24Months": {
          myDivName = "Total Commission for # months (CAD)";
          break;
        }
        default:
          myDivName = divName;
      }
    } else myDivName = divName;

    return myDivName;
  };

   const displayRules = (name) => {
    let BooleanResult = true;
    if (["Allowance"].includes(name)) {
      candidateCountry === "CAD"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    if (["Total Commission for # months"].includes(name)) {
      candidateCountry === "India"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    if (name === "leaveStateCd") {
      candidateCountry === "USA"
        ? (BooleanResult = true)
        : (BooleanResult = false);
    }
    if (
      [
        "provinceState",
        "statutoryHolidays",
        "vacationPayHourly",
        "vacationPayAnnual",
        "optionalHolidays",
      ].includes(name)
    ) {
      candidateCountry === "CAD"
        ? (BooleanResult = true)
        : (BooleanResult = false);
    }
    if (
      [
        "vacationNoOfDays",
        "candidateInsurenceType",
        "holidays",
        "immgirationType",
        "otherExpensesHourly",
        "totalCommissionForMonthPro",
        "recruiterMonthlyCommissionPro",
        "hourlyRate",
        "perDiemCount",
        "perDiem",
        "payRatePerDiem",
        // "grossMarginPercentage",
        "recuiterMonthlyCommissionPerHour",
      ].includes(name)
    ) {
      candidateCountry == "CAD"
        ? (BooleanResult = false)
        : (BooleanResult = true);
     }
      if (
      ["totalCommissionForMonthPro", "recruiterMonthlyCommissionPro"].includes(
        name
      )
    ) {
       BooleanResult = true;
    }
     if (["calculationCountry"].includes(name)) {
       BooleanResult = true;
    }
    if (["recMnthlyCommissionBonus"].includes(name)) {
      candidateCountry === "India"
        ? (BooleanResult = true)
        : (BooleanResult = false);
    }
    if (
      [
        "ttlMonthlyCommissionUSDVal",
        "recruiterMonthlyCommissionUSDVal",
      ].includes(name)
    ) {
      if (
        candidateCountry === "CAD"
      ) {
        BooleanResult = true;
      } else BooleanResult = false;
    }
    if (
      [
        "ttlMonthlyCommissionUSDVal",
        "recruiterMonthlyCommissionUSDVal",
      ].includes(name)
    ) {
      if (
        candidateCountry === "CAD"
      ) {
        BooleanResult = false;
      }
    }
    if (
      ["recruiterMonthlyCommission", "recruiterMonthlyCommission"].includes(
        name
      )
    ) {
      if (
        candidateCountry === "CAD"
      ) {
        BooleanResult = true;
      } else BooleanResult = false;
    }
    return BooleanResult;
  };

  const getLookupBucket = (key) =>
    Array.isArray(lookupData[key]) ? lookupData[key] : [];

  const getUniqueVmsOptions = (options) => {
    const seen = new Set();
    return Array.isArray(options)
      ? options.filter((option) => {
          const key = option?.customerNameWithFee ?? option?.vmsId ?? JSON.stringify(option);
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        })
      : [];
  };

  const getAvailableVmsOptions = () => {
    const allVmsOptions = Array.isArray(vmsFeeOptions) ? vmsFeeOptions : [];

    const filteredOptions = !businessUnit
      ? allVmsOptions
      : allVmsOptions.filter((option) => option?.bussinessUnit === businessUnit);

    return getUniqueVmsOptions(filteredOptions);
  };

  const chooseDropdoenOptions = (type) => {
    let options = [];
    switch (type) {
      case "COUNTRY":
        options = getLookupBucket("countries").map((country) => ({
          label: country.lookupLabel,
          value: country.lookupCd,
        }));
        break;
      case "CALCOUNTRY":
        options = getLookupBucket("calCountries").map((country) => ({
          label: country.lookupLabel,
          value: country.lookupCd,
        }));
        break;
      case "STATE":
        options = getLookupBucket("states").map((state) => ({
          label: state.lookupLabel,
          value: state.lookupCd,
        }));
        break;
      case "BUSINESSUNIT":
        if (candidateCountry === "CAD") {
          options = getLookupBucket("businessUnits")
            .filter((bu) => ["Canada", "BU07", "BU01"].includes(bu.lookupCd))
            .map((bu) => ({
              label: bu.lookupLabel,
              value: bu.lookupCd,
            }));
        } else {
          options = getLookupBucket("businessUnits")
            .filter((bu) => bu.lookupCd !== "Canada")
            .map((bu) => ({
              label: bu.lookupLabel,
              value: bu.lookupCd,
            }));
        }
        break;
      case "RESOURCETYPE":
        if (candidateCountry === "CAD") {
          options = getLookupBucket("resourceTypes")
            .filter((resourceType) =>
              ["T4", "C2C"].includes(resourceType.lookupCd)
            )
            .map((resourceType) => ({
              label: resourceType.lookupLabel,
              value: resourceType.lookupCd,
            }));
        } else {
          options = getLookupBucket("resourceTypes")
            .filter((resourceType) => resourceType.lookupCd !== "T4")
            .map((resourceType) => ({
              label: resourceType.lookupLabel,
              value: resourceType.lookupCd,
            }));
        }
        break;
      case "VMS":
        options = getAvailableVmsOptions().map((vms) => ({
          label: vms.customerNameWithFee,
          value: vms.vmsId,
        }));
        break;
      case "YESNO":
        options = getLookupBucket("yesNo").map((yn) => ({
          label: yn.lookupLabel,
          value: yn.lookupCd,
        }));
        break;
      case "PROVINCES_STRY_HLDY":
        options = getLookupBucket("provinces").map((province) => ({
          label: province.lookupLabel,
          value: province.lookupCd,
        }));
        break;
      case "INSURENCE":
        options = getLookupBucket("insuranceTypes").map((ins) => ({
          label: ins.lookupLabel,
          value: ins.lookupCd,
        }));
        break;
      case "IMMIGRATION":
        options = getLookupBucket("immigrationTypes").map((imm) => ({
          label: imm.lookupLabel,
          value: imm.lookupCd,
        }));
        break;
      default:
        options = [];
    }
    return options;
  };

  const currencySymbol = () => {
    // For guest users, use calculation country or default to USD
    return calCountry === "India" ? "₹" : "$";
  };
  
  const handleCountryToggle = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      setValue("candidateCountry", newAlignment);
    }
  };

  const fetchLookupData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/rcs/guest/getLookup`);
      if (!response.ok) throw new Error("Failed to fetch lookup data");

      const data = await response.json();
      const lookupItems = Array.isArray(data) ? data : [];

      // Parse and organize lookup data by type
      const organized = {
        countries: lookupItems.filter((d) => d.lookupType === "COUNTRY"),
        calCountries: lookupItems.filter((d) => d.lookupType === "CALCOUNTRY"),
        businessUnits: lookupItems.filter((d) => d.lookupType === "BUSINESSUNIT"),
        resourceTypes: lookupItems.filter((d) => d.lookupType === "RESOURCETYPE"),
        states: lookupItems.filter((d) => d.lookupType === "STATE"),
        provinces: lookupItems.filter(
          (d) => d.lookupType === "PROVINCES_STRY_HLDY"
        ),
        insuranceTypes: lookupItems.filter((d) => d.lookupType === "INSURENCE"),
        immigrationTypes: lookupItems.filter((d) => d.lookupType === "IMMIGRATION"),
        yesNo: lookupItems.filter((d) => d.lookupType === "YESNO"),
      };
      const sortedGroupedLookups = sortGroupedLookups(organized);
      setLookupData(sortedGroupedLookups);
      setError("");
    } catch (err) {
      setError(`Error fetching lookup data: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const fetchVMSFees = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/rcs/guest/getvmsdata?page=0&size=1000`);
      if (!response.ok) throw new Error("Failed to fetch VMS fees");

      const data = await response.json();
      const vmsItems = Array.isArray(data?.content)
        ? data.content
        : Array.isArray(data)
        ? data
        : [];

      setVmsFeeOptions(getUniqueVmsOptions(vmsItems));
      setError("");
    } catch (err) {
      setError(`Error fetching VMS fees: ${err.message}`);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      if (leaveStateCd) {
        const constFindObj = (lookupData?.states||[]).find(
          (obj) => obj.lookupCd === leaveStateCd
        );
      
        setHolidayDataTggle(constFindObj);
        if (constFindObj?.lookupVal === "0") {
          setHoliddayToggle(false);
        } else {
          setValue("vacationNoOfDays", constFindObj?.lookupVal ?? "0");
          setHoliddayToggle(true);
        }
      }
  }, [leaveStateCd, setValue, lookupData]);
  
  const parseNonNegativeInteger = (value) => {
    if (value === "" || value === null || value === undefined) {
      return 0;
    }

    const numericValue = Number(value);
    if (!Number.isFinite(numericValue) || numericValue < 0) {
      return 0;
    }

    const parsedValue = parseInt(value, 10);
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
  };

  const shouldUseLoginDefaults =
    loginData.roleCd === "RCTR" ||
    loginData.roleCd === "ACCMNGR" ||
    loginData.country === "India";

  const calculateEndpoint = async (payload) => {
    if (loginData?.id) {
      const response = await calculateData(payload);
      return response?.data;
    }

    const response = await fetch(`${API_BASE_URL}/rcs/guest/calculate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.statusText}`);
    }

    return response.json();
  };

  const buildCalculationPayload = (formValues) => {
    return {
      ...formValues,
      allowedMarkupPct: formValues.allowedMarkupPct || null,
      candidateTypeOfResource: formValues.candidateTypeOfResource || "W2",
      candidateName: formValues.candidateName || null,
      candidateJobTitle: formValues.candidateJobTitle || null,
      candidateStartDt: formValues.candidateStartDt || null,
      onboardingDt: formValues.onboardingDt || null,
      terminationDt: formValues.terminationDt || null,
      tnVisaPremiumYN: formValues.tnVisaPremiumYN || null,
      candidateDetailId: formValues.candidateDetailId || null,
      jobId: formValues.jobId || null,
      totalCommissionFor24Months: 24,
      payRate: formValues.payRate ? parseFloat(formValues.payRate) : 400.00,
      candidateBillRate: formValues.candidateBillRate ? parseFloat(formValues.candidateBillRate) : 2000.00,
      vmsFee: formValues.vmsFee ? parseInt(formValues.vmsFee) : 231,
      perDiem: null,
      maxPay: null,
      payRatePerDiem: null,
      b2biMargin: null,
      grossMarginPercentage: null,
      candidateJobID: null,
      grossMarginDollar: null,
      blendedGrossMarginPercentage: null,
      recuiterMonthlyCommission: null,
      recruiterMonthlyCommission: null,
      recuiterMonthlyCommissionPerHour: null,
      provinceState: null,
      recuiterTotCommissionForMonths: null,
      vacationPayHourly: null,
      vacationPayAnnual: null,
      ttlMonthlyCommissionUSDVal: null,
      recruiterMonthlyCommissionUSDVal: null,
      hourlyRate: null,
      recMnthlyCommissionBonus: null,
      maxMarkup: 0,
      tnVisaCountry: null,
      statutoryHolidays: formValues.statutoryHolidays
        ? parseNonNegativeInteger(formValues.statutoryHolidays)
        : 0,
      optionalHolidays: formValues.optionalHolidays
        ? parseNonNegativeInteger(formValues.optionalHolidays)
        : 0,
      perDiemCount: formValues.perDiemCount
        ? parseNonNegativeInteger(formValues.perDiemCount)
        : 0,
      calculationCountry: shouldUseLoginDefaults
        ? loginData.country
        : formValues.calculationCountry,
      candidateBusinessUnit:
        formValues.candidateTypeOfResource === "C2C"
          ? formValues.candidateBusinessUnit || null
          : formValues.candidateBusinessUnit,
      holidays:
        formValues.candidateTypeOfResource === "C2C" ||
        formValues.candidateCountry === "CAD"
          ? formValues.holidays || "NO"
          : formValues.holidays,
      candidateInsurenceType:
        formValues.candidateTypeOfResource === "C2C" ||
        formValues.candidateCountry === "CAD"
          ? formValues.candidateInsurenceType || "NON"
          : formValues.candidateInsurenceType,
      immgirationType:
        formValues.candidateTypeOfResource === "C2C" ||
        formValues.candidateCountry === "CAD"
          ? formValues.immgirationType || "NO"
          : formValues.immgirationType,
      vacationNoOfDays:
        formValues.candidateTypeOfResource === "C2C" ||
        formValues.candidateCountry === "CAD"
          ? formValues.vacationNoOfDays &&
            formValues.vacationNoOfDays >= 0
            ? parseInt(formValues.vacationNoOfDays)
            : 0
          : formValues.vacationNoOfDays || 0,
      sickLeaveNoOfDays:
        formValues.candidateTypeOfResource === "C2C" ||
        formValues.candidateCountry === "CAD"
          ? formValues.sickLeaveNoOfDays &&
            formValues.sickLeaveNoOfDays >= 0
            ? parseInt(formValues.sickLeaveNoOfDays)
            : 0
          : formValues.sickLeaveNoOfDays || 0,
      otherExpenses:
        formValues.candidateTypeOfResource === "C2C"
          ? formValues.otherExpenses && formValues.otherExpenses >= 0
            ? parseInt(formValues.otherExpenses)
            : 0
          : formValues.otherExpenses || 0,
      otherExpensesHourly:
        formValues.candidateTypeOfResource === "C2C" ||
        formValues.candidateCountry === "CAD"
          ? formValues.otherExpensesHourly &&
            formValues.otherExpensesHourly >= 0
            ? parseInt(formValues.otherExpensesHourly)
            : 0
          : formValues.otherExpensesHourly || 0,
      refferalAmount:
        formValues.candidateTypeOfResource === "C2C"
          ? formValues.refferalAmount && formValues.refferalAmount >= 0
            ? parseInt(formValues.refferalAmount)
            : 0
          : formValues.refferalAmount || 0,
      recruiterCountry: formValues.calculationCountry,
      preId: "NO"
    };
  };

  const handleCalculate = async (formValues) => {
    try {
      setLoading(true);
      setError("");
      setSuccess("");

      const payload = buildCalculationPayload(formValues);
      const result = await calculateEndpoint(payload);
      setCalculationResult(result);
      setCalculatedOnce(true);

      reset({
        candidateName: formValues.candidateName,
        candidateJobTitle: formValues.candidateJobTitle,
        jobId: result.jobId || null,
        candidateStartDt: result.candidateStartDt
          ? dayjs(result.candidateStartDt).format("YYYY-MM-DD")
          : formValues.candidateStartDt,
        candidateBillRate: formValues.candidateBillRate,
        payRate: formValues.payRate,
        candidateCountry: formValues.candidateCountry,
        calculationCountry: formValues.calculationCountry,
        candidateBusinessUnit: formValues.candidateBusinessUnit,
        candidateTypeOfResource: formValues.candidateTypeOfResource || "W2",
        vmsFee: Number(formValues.vmsFee) || 231,
        recruiterName: formValues.recruiterName,
        accountExecutive: formValues.accountExecutive,
        
        totalCommissionFor24Months: result.totalCommissionFor24Months || 24,
        recuiterTotCommissionForMonths: result.recuiterTotCommissionForMonths ? String(result.recuiterTotCommissionForMonths) : "0.00",
        perDiemCount: result.perDiemCount || 0,
        perDiem: result.perDiem ? String(result.perDiem) : "0.00",

        maxPay: result.maxPay ? String(result.maxPay) : null,
        payRatePerDiem: result.payRatePerDiem ? String(result.payRatePerDiem) : null,
        b2biMargin: result.b2biMargin ? String(result.b2biMargin) : null,
        grossMarginPercentage: result.grossMarginPercentage ? String(result.grossMarginPercentage) : null,
        grossMarginDollar: result.grossMarginDollar ? String(result.grossMarginDollar) : null,
        blendedGrossMarginPercentage: result.blendedGrossMarginPercentage ? String(result.blendedGrossMarginPercentage) : null,
        recuiterMonthlyCommission: result.recuiterMonthlyCommission ? Number(result.recuiterMonthlyCommission) : null,
        recMnthlyCommissionBonus: result.recMnthlyCommissionBonus ? String(result.recMnthlyCommissionBonus) : null,
        recuiterMonthlyCommissionPerHour: result.recuiterMonthlyCommissionPerHour ? String(result.recuiterMonthlyCommissionPerHour) : null,
        totalCommissionForMonthPro: result.totalCommissionForMonthPro ? String(result.totalCommissionForMonthPro) : null,
        recruiterMonthlyCommissionPro: result.recruiterMonthlyCommissionPro ? String(result.recruiterMonthlyCommissionPro) : null,
        ttlMonthlyCommissionUSDVal: result.ttlMonthlyCommissionUSDVal ? String(result.ttlMonthlyCommissionUSDVal) : null,
        recruiterMonthlyCommissionUSDVal: result.recruiterMonthlyCommissionUSDVal ? String(result.recruiterMonthlyCommissionUSDVal) : null,
        hourlyRate: result.hourlyRate ? String(result.hourlyRate) : null,
        allowedMarkupPct: result.allowedMarkupPct || "No Markup",
        maxMarkup: result.maxMarkup ? String(result.maxMarkup) : 0,
        
        sickLeaveNoOfDays: result.sickLeaveNoOfDays || 0,
        vacationNoOfDays: result.vacationNoOfDays || formValues.vacationNoOfDays || 0,
        holidays: formValues.holidays || result.holidays || "",
        candidateInsurenceType: formValues.candidateInsurenceType || result.candidateInsurenceType || "",
        immgirationType: formValues.immgirationType || result.immgirationType || "",
        refferalAmount: formValues.refferalAmount || result.refferalAmount || 0,
        otherExpenses: formValues.otherExpenses || result.otherExpenses || 0,
        otherExpensesHourly: formValues.otherExpensesHourly || result.otherExpensesHourly || 0,
        
        provinceState: result.provinceState || formValues.provinceState || "",
        statutoryHolidays: result.statutoryHolidays || 0,
        vacationPayHourly: result.vacationPayHourly || 0,
        vacationPayAnnual: result.vacationPayAnnual || 0,
        optionalHolidays: result.optionalHolidays || 0,
        
        onboardingDt: result.onboardingDt
          ? dayjs(result.onboardingDt).format("YYYY-MM-DD")
          : formValues.onboardingDt,
        terminationDt: result.terminationDt
          ? dayjs(result.terminationDt).format("YYYY-MM-DD")
          : formValues.terminationDt,
        
        tnVisaCountry: formValues.tnVisaCountry || result.tnVisaCountry || "",
        leaveStateCd: result.leaveStateCd || formValues.leaveStateCd || "",
      });

      setValue("totalCommissionFor24Months", result.totalCommissionFor24Months || 24);
      setValue("recuiterTotCommissionForMonths", result.recuiterTotCommissionForMonths ? String(result.recuiterTotCommissionForMonths) : "0.00");
      setValue("perDiem", result.perDiem ? String(result.perDiem) : "0.00");
      setValue("maxPay", result.maxPay ? String(result.maxPay) : 0);
      setValue("payRatePerDiem", result.payRatePerDiem ? String(result.payRatePerDiem) : 0);
      setValue("b2biMargin", result.b2biMargin ? String(result.b2biMargin) : 0);
      setValue("grossMarginPercentage", result.grossMarginPercentage ? String(result.grossMarginPercentage) : 0);
      setValue("grossMarginDollar", result.grossMarginDollar ? String(result.grossMarginDollar) : 0);
      setValue("blendedGrossMarginPercentage", result.blendedGrossMarginPercentage ? String(result.blendedGrossMarginPercentage) : 0);
      setValue("recuiterMonthlyCommission", result.recuiterMonthlyCommission ? String(result.recuiterMonthlyCommission) : 0);
      setValue("recMnthlyCommissionBonus", result.recMnthlyCommissionBonus ? String(result.recMnthlyCommissionBonus) : 0);
      setValue("recuiterMonthlyCommissionPerHour", result.recuiterMonthlyCommissionPerHour ? (result.recuiterMonthlyCommissionPerHour) : 0);
      setValue("totalCommissionForMonthPro", result.totalCommissionForMonthPro ? (result.totalCommissionForMonthPro) : 0);
      setValue("recruiterMonthlyCommissionPro", result.recruiterMonthlyCommissionPro ? String(result.recruiterMonthlyCommissionPro) : 0);
      setValue("ttlMonthlyCommissionUSDVal", result.ttlMonthlyCommissionUSDVal ? String(result.ttlMonthlyCommissionUSDVal) : 0);
      setValue("recruiterMonthlyCommissionUSDVal", result.recruiterMonthlyCommissionUSDVal ? String(result.recruiterMonthlyCommissionUSDVal) : 0);
      setValue("hourlyRate", result.hourlyRate ? String(result.hourlyRate) : 0);
      setValue("allowedMarkupPct", result.allowedMarkupPct || "No Markup");
      setValue("maxMarkup", result.maxMarkup ? String(result.maxMarkup) : 0);
      setValue("vacationPayHourly", result.vacationPayHourly || 0);
      setValue("vacationPayAnnual", result.vacationPayAnnual || 0);
      
      setSuccess("Calculation completed successfully!");
    } catch (err) {
      setError(`Calculation failed: ${err.message}`);
      setSuccess("");
      setCalculatedOnce(false);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    if (!calculatedOnce || !calculationResult) return;

    try {
      setLoading(true);
      setError("");

      const formValues = getValues();
      const payload = buildCalculationPayload(formValues);

      const response = await fetch(`${API_BASE_URL}/rcs/guest/calculate/export/pdf`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Export failed: ${response.statusText}`);
      }

      // Get the PDF file blob from response
      const blob = await response.blob();
      const fileName = `calculation-result-${dayjs().format("YYYYMMDD_HHmmss")}.pdf`;
 
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      setSuccess("Export completed successfully!");
    } catch (err) {
      setError(`Export failed: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLookupData();
    fetchVMSFees();
  }, []);

  useEffect(() => {
    if (workingLocation) {
      setAlignment(workingLocation);
    }
  }, [workingLocation]);

  useEffect(() => {
    const businessUnits = getLookupBucket("businessUnits");
    if (!Array.isArray(businessUnits) || businessUnits.length === 0) {
      return; // Skip validation until data is loaded
    }

    const availableBusinessUnits =
      candidateCountry === "CAD"
        ? businessUnits.filter((option) =>
            ["Canada", "BU07", "BU01"].includes(option.lookupCd)
          )
        : businessUnits.filter(
            (option) => option.lookupCd !== "Canada"
          );
    const selectedBusinessUnitExists = availableBusinessUnits.some(
      (option) => option.lookupCd === businessUnit
    );

    if (businessUnit && !selectedBusinessUnitExists) {
      setValue("candidateBusinessUnit", "");
      setValue("vmsFee", "");
      setValue("allowedMarkupPct", "");
    }
  }, [businessUnit, candidateCountry, lookupData.businessUnits, setValue]);

  useEffect(() => {

    const resourceTypes = getLookupBucket("resourceTypes");
    if (!Array.isArray(resourceTypes) || resourceTypes.length === 0) {
      return; // Skip validation until data is loaded
    }

    const availableResourceTypes =
      candidateCountry === "CAD"
        ? resourceTypes.filter((option) =>
            ["T4", "C2C"].includes(option.lookupCd)
          )
        : resourceTypes.filter(
            (option) => option.lookupCd !== "T4"
          );
    const selectedResourceTypeExists = availableResourceTypes.some(
      (option) => option.lookupCd === candidateTypeOfResource
    );

    if (candidateCountry === "CAD") {
      if (!candidateTypeOfResource || !selectedResourceTypeExists) {
        setValue("candidateTypeOfResource", "T4");
        return;
      }
    } else {
      // USA
      if (!candidateTypeOfResource || !selectedResourceTypeExists) {
        setValue("candidateTypeOfResource", "W2");
        return;
      }
    }
  }, [
    candidateCountry,
    candidateTypeOfResource,
    lookupData.resourceTypes,
    setValue,
  ]);

  useEffect(() => {
    if (immigration !== "4000") {
      setValue("tnVisaCountry", "");
    }
  }, [immigration, setValue]);

  useEffect(() => {
    if (!Array.isArray(vmsFeeOptions) || vmsFeeOptions.length === 0) {
      return; // Skip validation until data is loaded
    }

    const availableVmsOptions = vmsFeeOptions.filter(
      (option) => !businessUnit || option?.bussinessUnit === businessUnit
    );
    const selectedVms = availableVmsOptions.find(
      (option) => String(option?.vmsId) === String(vmsFee)
    );

    if (!selectedVms && vmsFee) {
      setValue("vmsFee", "");
    }

    setValue(
      "allowedMarkupPct",
      selectedVms?.allowedMarkupPct
        ? selectedVms.allowedMarkupPct === "NA"
          ? "No Markup"
          : selectedVms.allowedMarkupPct
        : "--"
    );
  }, [businessUnit, vmsFee, vmsFeeOptions, setValue]);

  const handleClear = () => {
    reset({
      candidateName: "",
      candidateJobTitle: "",
      jobId: null,
      candidateStartDt: "",
      candidateBillRate: "",
      payRate: "",
      candidateCountry: "USA",
      calculationCountry: "USA",
      candidateBusinessUnit: "",
      candidateTypeOfResource: "W2",
      vmsFee: 231,
      sickLeaveNoOfDays: 0,
      refferalAmount: 0,
      otherExpenses: 0,
      candidateInsurenceType: "NON",
      holidays: "NO",
      immgirationType: "NO",
      otherExpensesHourly: 0,
      vacationNoOfDays: 0,
      totalCommissionFor24Months: 24,
      perDiemCount: 0,
      allowedMarkupPct: "",
      provinceState: "",
      statutoryHolidays: 0,
      optionalHolidays: 0,
      tnVisaCountry: "",
      leaveStateCd: "",
      recruiterName: "",
      accountExecutive: "",
      onboardingDt: "",
      terminationDt: "",
      vacationPayHourly: 0,
      vacationPayAnnual: 0,
      recuiterTotCommissionForMonths: "",
      // Clear result fields
      perDiem: "0.00",
      maxPay: "",
      payRatePerDiem: "",
      b2biMargin: "",
      grossMarginPercentage: "",
      grossMarginDollar: "",
      blendedGrossMarginPercentage: "",
      recuiterMonthlyCommission: "",
      recMnthlyCommissionBonus: "",
      recuiterMonthlyCommissionPerHour: "",
      totalCommissionForMonthPro: null,
      recruiterMonthlyCommissionPro: null,
      ttlMonthlyCommissionUSDVal: "",
      recruiterMonthlyCommissionUSDVal: "",
      hourlyRate: "",
      maxMarkup: "",
    });
    setCalculationResult(null);
    setCalculatedOnce(false);
    setError("");
    setSuccess("");
  };

  return (
    <Box sx={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <Typography variant="h5" sx={{ marginBottom: "10px", fontWeight: 700 }}>
        Rate Calculator
      </Typography>

      {error && (
        <Alert severity="error" sx={{ marginBottom: "20px" }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ marginBottom: "20px" }}>
          {success}
        </Alert>
      )}

      <Box sx={{ display: "flex", justifyContent: "center", marginBottom: "30px" }}>
        <ToggleButtonGroup
          sx={{
            backgroundColor: "#EEEEEE",
            borderRadius: "15px",
            border: "solid 0.5px #616161",
          }}
          value={alignment}
          exclusive
          onChange={handleCountryToggle}
          aria-label="country"
        >
          <ToggleButton
            value="USA"
            sx={{
              display: "flex",
              gap: "10px",
              textTransform: "capitalize",
              "&.Mui-selected, &.Mui-selected:hover": {
                backgroundColor: "#616161",
              },
              borderRadius: "14px",
              backgroundColor: "white",
            }}
          >
            <Box className={classes.usFlag} />
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: 15,
                fontWeight: alignment === "USA" ? "bold" : 500,
                color: alignment === "USA" ? "#FFFF" : "#6c6c6c",
              }}
            >
              United State
            </Typography>
          </ToggleButton>

          <ToggleButton
            value="CAD"
            sx={{
              display: "flex",
              gap: "10px",
              textTransform: "capitalize",
              "&.Mui-selected, &.Mui-selected:hover": {
                color: "#FFFF",
                backgroundColor: "#616161",
              },
              borderRadius: "14px",
              outline: alignment === "CAD" ? "solid 1px gray" : "none",
              backgroundColor: "white",
            }}
          >
            <Box className={classes.CANADAflag} />
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: alignment === "CAD" ? "bold" : 500,
                color: alignment === "CAD" ? "#FFFF" : "#6c6c6c",
              }}
            >
              Canada
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Accordion defaultExpanded sx={{ marginBottom: "30px" }}>
        <AccordionSummary
          sx={{
            border: "#D9D9D9 solid 1px",
            boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="employee-info-content"
          id="employee-info-header"
        >
          <Typography sx={{ fontWeight: 700 }}>Employee Information</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Field label="Candidate Name">
                <CoTextField
                  name="candidateName"
                  control={control}
                  normalizers={onlyAlphabetWithSpace}
                />
              </Field>
            </Grid>
            <Grid item xs={4}>
              <Field label="Job Title">
                <CoTextField
                  normalizers={[alphaNumeric]}
                  name="candidateJobTitle"
                  control={control}
                />
              </Field>
            </Grid>
            <Grid item xs={4}>
              <Field label="Job ID">
                <CoTextField
                  name="jobId"
                  control={control}
                  normalizers={[alphaNumeric]}
                />
              </Field>
            </Grid>
            <Grid item xs={4}>
              <Field label="Start Date" isDate>
                <CoDatePicker
                  name="candidateStartDt"
                  control={control}
                />
              </Field>
            </Grid>
             {displayRules("onboardingDt") &&
                                      !visibleAccess["onboardingDt"] && (
                                        <Grid item xs={4}>
                                          <Field label="On Bording Date" isDate>
                                            <CoDatePicker
                                              minDate={dayjs(getValues("candidateStartDt"))}
                                              name="onboardingDt"
                                              control={control}
                                            />
                                          </Field>
                                        </Grid>
                                      )}
                                    {displayRules("terminationDt") &&
                                      !visibleAccess["terminationDt"] && (
                                        <Grid item xs={4}>
                                          <Field label="Termination Date" isDate>
                                            <CoDatePicker
                                              minDate={dayjs(getValues("candidateStartDt"))}
                                              name="terminationDt"
                                              control={control}
                                            />
                                          </Field>
                                        </Grid>
                                      )}
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded sx={{ marginBottom: "30px" }}>
        <AccordionSummary
          sx={{
            border: "#D9D9D9 solid 1px",
            boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="billing-staffing-content"
          id="billing-staffing-header"
        >
          <Typography sx={{ fontWeight: 700 }}>Billing & Staffing Information</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Field label="Bill Rate"
                required
                error={errors.candidateBillRate?.message}
                showError={errors.candidateBillRate?.message}
              >
                <CoTextField
                  name="candidateBillRate"
                  control={control}
                  normalizers={[formatCurrency]}
                  startAdornment={
                    <InputAdornment position="start">$</InputAdornment>
                  }
                />
              </Field>
            </Grid>
            <Grid item xs={4}>
              <Field label="Pay Rate"
                required
                error={errors.payRate?.message}
                showError={errors.payRate?.message}
              >
                <CoTextField
                  name="payRate"
                  control={control}
                  normalizers={[formatCurrency]}
                  startAdornment={
                    <InputAdornment position="start">$</InputAdornment>
                  }
                />
              </Field>
            </Grid>
            <Grid item xs={4}>
              <Field label="Working Location"
              >
                <CoDropdown
                  name="candidateCountry"
                  control={control}
                  options={chooseDropdoenOptions("COUNTRY")}
                />
              </Field>
            </Grid>
            {displayRules("calculationCountry") && (
              <Grid item xs={4}>
                <Field label="Calculation Location"
                >
                  <CoDropdown
                    name="calculationCountry"
                    control={control}
                    options={chooseDropdoenOptions("CALCOUNTRY")}
                  />
                </Field>
              </Grid>
            )}
            {( watch("candidateCountry") === "USA") && (
              <Grid item xs={4}>
                <Field label="State">
                  <CoDropdown
                    name="leaveStateCd"
                    control={control}
                    options={chooseDropdoenOptions("STATE")}
                  />
                </Field>
              </Grid>
            )}
            <Grid item xs={4}>
              <Field label="Business Unit"
              >
                <CoDropdown
                  name="candidateBusinessUnit"
                  control={control}
                  options={chooseDropdoenOptions("BUSINESSUNIT")}
                />
              </Field>
            </Grid>
            <Grid item xs={4}>
              <Field label="Type of Resource"
              >
                <CoDropdown
                  name="candidateTypeOfResource"
                  control={control}
                  options={chooseDropdoenOptions("RESOURCETYPE")}
                />
              </Field>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded sx={{ marginBottom: "30px" }}>
        <AccordionSummary
          sx={{
            border: "#D9D9D9 solid 1px",
            boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="compensation-benefits-content"
          id="compensation-benefits-header"
        >
          <Typography sx={{ fontWeight: 700 }}>Compensation & Benefits</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Field label="VMS Fee"
              >
                <CoDropdown
                  name="vmsFee"
                  control={control}
                  options={chooseDropdoenOptions("VMS")}
                />
              </Field>
            </Grid>
            <Grid item xs={4}>
              <Field label="Allowed Markup">
                <CoTextField
                  name="allowedMarkupPct"
                  control={control}
                  disabled={true}
                  isPercentage={true}
                />
              </Field>
            </Grid>
            {displayRules("holidays") && (
              <Grid item xs={4}>
                 <Field label="Holidays (6 Days)"
                >
                  <CoDropdown
                    name="holidays"
                    control={control}
                    options={chooseDropdoenOptions("YESNO")}
                  />
                </Field>
              </Grid>
            )}
         
          {(displayRules("provinceState") ||
            displayRules("vacationPayHourly") ||
            displayRules("vacationPayAnnual")) && (
            <>
              {displayRules("provinceState") && (
                <Grid item xs={4}>
                  <Field label="Province State">
                    <CoDropdown
                      name="provinceState"
                      control={control}
                      options={chooseDropdoenOptions("PROVINCES_STRY_HLDY")}
                    />
                  </Field>
                </Grid>
              )}
              {displayRules("vacationPayHourly") && (
                <Grid item xs={4}>
                  <Field label="4% Vacation Pay Hourly">
                    <CoTextField
                      name="vacationPayHourly"
                      control={control}
                      disabled
                    />
                  </Field>
                </Grid>
              )}
              {displayRules("vacationPayAnnual") && (
                <Grid item xs={4}>
                  <Field label="4% Vacation Pay Annual">
                    <CoTextField
                      name="vacationPayAnnual"
                      control={control}
                      disabled
                    />
                  </Field>
                </Grid>
              )}
            </>
          )}
            {displayRules("statutoryHolidays") && (
              <Grid item xs={4}>
                <Field label="Statutory Holidays">
                  <CoTextField
                    name="statutoryHolidays"
                    control={control}
                    normalizers={[number]}
                  />
                </Field>
              </Grid>
            )}
            {displayRules("vacationNoOfDays") && (
              <Grid item xs={4}>
                <Field label="Vacation (# of Days)"
                >
                  <CoTextField
                    name="vacationNoOfDays"
                    control={control}
                    normalizers={[decimalValue]}
                  />
                </Field>
              </Grid>
            )}
            {displayRules("sickLeaveNoOfDays") && (
              <Grid item xs={4}>
                <Field label="Sick Leave (# of Days)"
                >
                  <CoTextField
                    name="sickLeaveNoOfDays"
                    control={control}
                    normalizers={[number]}
                  />
                </Field>
              </Grid>
            )}
            {displayRules("optionalHolidays") && (
              <Grid item xs={4}>
                <Field label="Optional Holidays">
                  <CoTextField
                    name="optionalHolidays"
                    control={control}
                    normalizers={[number]}
                  />
                </Field>
              </Grid>
            )}
            {displayRules("candidateInsurenceType") && (
              <Grid item xs={4}>
                <Field label="Insurance Type"
                >
                  <CoDropdown
                    name="candidateInsurenceType"
                    control={control}
                    options={chooseDropdoenOptions("INSURENCE")}
                  />
                </Field>
              </Grid>
            )}
            {displayRules("refferalAmount") && (
              <Grid item xs={4}>
                <Field label="Referral Fee"
                >
                  <CoTextField
                    name="refferalAmount"
                    control={control}
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">$</InputAdornment>
                    }
                  />
                </Field>
              </Grid>
            )}
            {displayRules("immgirationType") && (
              <Grid item xs={4}>
                <Field label="Immigration"
                >
                  <CoDropdown
                    name="immgirationType"
                    control={control}
                    options={chooseDropdoenOptions("IMMIGRATION")}
                  />
                </Field>
              </Grid>
            )}
            {displayRules("otherExpenses") && (
              <Grid item xs={4}>
                <Field label="Other Exp-Fixed Dollar"
                >
                  <CoTextField
                    name="otherExpenses"
                    control={control}
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">$</InputAdornment>
                    }
                  />
                </Field>
              </Grid>
            )}
            {displayRules("otherExpensesHourly") && (
              <Grid item xs={4}>
                <Field label="Other Expenses-Hourly"
                >
                  <CoTextField
                    name="otherExpensesHourly"
                    control={control}
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">$</InputAdornment>
                    }
                  />
                </Field>
              </Grid>
            )}
          </Grid>
          {immigration === "4000" && (
            <Grid container>
              <Grid item xs={5}>
                <Controller
                  name="tnVisaCountry"
                  control={control}
                  render={({ field }) => (
                    <RadioGroup row {...field}>
                      <FormControlLabel
                        label="Canada"
                        value="CA"
                        control={
                          <Checkbox
                            checked={field.value === "CA"}
                            onChange={() => setValue("tnVisaCountry", "CA")}
                          />
                        }
                      />
                      <FormControlLabel
                        label="Mexico"
                        value="MX"
                        control={
                          <Checkbox
                            checked={field.value === "MX"}
                            onChange={() => setValue("tnVisaCountry", "MX")}
                          />
                        }
                      />
                    </RadioGroup>
                  )}
                />
                <p style={{ color: "#d32f2f", fontSize: "0.8rem" }}>
                  {errors.tnVisaCountry?.message}
                </p>
              </Grid>
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>

      
      {displayRules("Total Commission for # months") &&
                  displayRules("Allowance") && (
                    <Grid item xs={12}>
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          sx={{
                            border: "#D9D9D9 solid 1px",
                            boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                          }}
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography sx={{ fontWeight: 700 }}>
                            Commission & Allowance
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={2}>
                            {displayRules("Total Commission for # months") && (
                              <Grid item xs={6}>
                                <Field
                                  label={setMydivName(
                                    "totalCommissionFor24Months",
                                    "Total Commission for # months"
                                  )}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      gap: "14px",
                                    }}
                                  >
                                    <CoTextField
                                      name="totalCommissionFor24Months"
                                      control={control}
                                      normalizers={[number]}
                                      sx={{ width: "100%" }}
                                    />
                                    <CoTextField
                                      name="recuiterTotCommissionForMonths"
                                      control={control}
                                      sx={{ width: "100%" }}
                                      disabled={true}
                                      startAdornment={
                                        <InputAdornment position="start">
                                          {currencySymbol()}
                                        </InputAdornment>
                                      }
                                    />
                                  </Box>
                                </Field>
                              </Grid>
                            )}
                            {displayRules("Allowance") && (
                              <Grid item xs={6}>
                                <Field label="Allowance">
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      gap: "14px",
                                    }}
                                  >
                                    <CoTextField
                                      name="perDiemCount"
                                      control={control}
                                      normalizers={[number]}
                                      sx={{ width: "100%" }}
                                    />
                                    <CoTextField
                                      name="perDiem"
                                      control={control}
                                      sx={{ width: "100%" }}
                                      disabled={true}
                                    />
                                  </Box>
                                </Field>
                              </Grid>
                            )}
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  )}
      <Accordion expanded={calculatedOnce} sx={{ marginBottom: "30px" }}>
        <AccordionSummary
          sx={{
            border: "#D9D9D9 solid 1px",
            boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="pay-expenses-content"
          id="pay-expenses-header"
        >
          <Typography sx={{ fontWeight: 700 }}>Pay & Expenses</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Field label="Max Pay (including Allowance)">
                <CoTextField
                  name="maxPay"
                  control={control}
                  disabled={true}
                  normalizers={[formatCurrency]}
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol()}
                    </InputAdornment>
                  }
                />
              </Field>
            </Grid>
            {displayRules("payRatePerDiem") && (
              <Grid item xs={4}>
                <Field label="Pay Rate Allowance">
                  <CoTextField
                    name="payRatePerDiem"
                    control={control}
                    disabled={true}
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">
                        {currencySymbol()}
                      </InputAdornment>
                    }
                  />
                </Field>
              </Grid>
            )}
            <Grid item xs={4}>
              <Field label="B2BI Margin">
                <CoTextField
                  name="b2biMargin"
                  control={control}
                  isPercentage={true}
                  disabled={true}
                />
              </Field>
            </Grid>
          
          {/* <Grid container spacing={2}> */}
            <Grid item xs={4}>
              <Field label="Gross Margin">
                <CoTextField
                  name="grossMarginPercentage"
                  control={control}
                  isPercentage={true}
                  disabled={true}
                />
              </Field>
            </Grid>
            <Grid item xs={4}>
              <Field label="Gross Margin in $">
                <CoTextField
                  name="grossMarginDollar"
                  control={control}
                  disabled={true}
                  normalizers={[formatCurrency]}
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol()}
                    </InputAdornment>
                  }
                />
              </Field>
            </Grid>
            <Grid item xs={4}>
              <Field label="Blended Gross Margin">
                <CoTextField
                  name="blendedGrossMarginPercentage"
                  control={control}
                  isPercentage={true}
                  disabled={true}
                />
              </Field>
            </Grid>
          {/* </Grid> */}
          {/* <Grid container spacing={2}> */}
            {displayRules("recuiterMonthlyCommission") && (
              <Grid item xs={4}>
                <Field label="Recruiter Monthly Commission">
                  <CoTextField
                    name="recuiterMonthlyCommission"
                    control={control}
                    disabled={true}
                    startAdornment={
                      <InputAdornment position="start">
                        {currencySymbol()}
                      </InputAdornment>
                    }
                  />
                </Field>
              </Grid>
            )}
            {displayRules("recMnthlyCommissionBonus") && (
              <Grid item xs={4}>
                <Field label="Recruiter Monthly Commission Bonus">
                  <CoTextField
                    name="recMnthlyCommissionBonus"
                    control={control}
                    disabled={true}
                    startAdornment={
                      <InputAdornment position="start">
                        {currencySymbol()}
                      </InputAdornment>
                    }
                  />
                </Field>
              </Grid>
            )}
            {displayRules("recuiterMonthlyCommissionPerHour") &&
              candidateCountry !== "CAD" && (
                <Grid item xs={4}>
                  <Field label="Recruiter Monthly Commission per hour worked">
                    <CoTextField
                      name="recuiterMonthlyCommissionPerHour"
                      control={control}
                      disabled={true}
                      normalizers={[formatCurrency]}
                      startAdornment={
                        <InputAdornment position="start">
                          {currencySymbol()}
                        </InputAdornment>
                      }
                    />
                  </Field>
                </Grid>
              )}
          {/* </Grid> */}
          {/* <Grid container spacing={2}> */}
            {displayRules("totalCommissionForMonthPro") &&
              candidateCountry !== "CAD" && (
                <Grid item xs={4}>
                  <Field label="Total AE Commission">
                    <CoTextField
                      name="totalCommissionForMonthPro"
                      control={control}
                      disabled={true}
                      normalizers={[formatCurrency]}
                      startAdornment={
                        <InputAdornment position="start">
                          {currencySymbol()}
                        </InputAdornment>
                      }
                    />
                  </Field>
                </Grid>
              )}
            {displayRules("recruiterMonthlyCommissionPro") &&
              candidateCountry !== "CAD" && (
                <Grid item xs={4}>
                  <Field label="AE Recruiter Monthly Commission">
                    <CoTextField
                      name="recruiterMonthlyCommissionPro"
                      control={control}
                      disabled={true}
                      normalizers={[formatCurrency]}
                      startAdornment={
                        <InputAdornment position="start">
                          {currencySymbol()}
                        </InputAdornment>
                      }
                    />
                  </Field>
                </Grid>
              )}
            {displayRules("ttlMonthlyCommissionUSDVal") && (
              <Grid item xs={4}>
                <Field label="Total Commission for # months (USD)">
                  <CoTextField
                    name="ttlMonthlyCommissionUSDVal"
                    control={control}
                    disabled={true}
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">$</InputAdornment>
                    }
                  />
                </Field>
              </Grid>
            )}
          {/* </Grid> */}
          {/* <Grid container spacing={2} mt={2}> */}
            {displayRules("recruiterMonthlyCommissionUSDVal") && (
              <Grid item xs={4}>
                <Field label="Recruiter Monthly Commission(USD)">
                  <CoTextField
                    name="recruiterMonthlyCommissionUSDVal"
                    control={control}
                    disabled={true}
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">$</InputAdornment>
                    }
                  />
                </Field>
              </Grid>
            )}
            {displayRules("hourlyRate") && candidateCountry !== "CAD" && (
              <Grid item xs={4}>
                <Field label="Hourly Rate">
                  <CoTextField
                    name="hourlyRate"
                    control={control}
                    disabled={true}
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">
                        {currencySymbol()}
                      </InputAdornment>
                    }
                  />
                </Field>
              </Grid>
            )}
            {/* {calculationResult?.maxMarkup != null && (
              <Grid item xs={4}>
                <Field label="Max Markup Pct">
                  <CoTextField
                    name="maxMarkup"
                    control={control}
                    disabled={true}
                    isPercentage={true}
                  />
                </Field>
              </Grid>
            )} */}
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Action Buttons */}
      <Box sx={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          onClick={handleClear}
          disabled={loading}
          sx={{ textTransform: "capitalize" }}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit(handleCalculate, () => {
            setError("Please fill all required fields");
            setSuccess("");
          })}
          disabled={loading}
          sx={{ backgroundColor: "#44A0E3", textTransform: "capitalize" }}
        >
          {loading ? <CircularProgress size={24} /> : "Calculate"}
        </Button>
        <Button
          variant="outlined"
          onClick={handleExport}
          disabled={!calculatedOnce || loading}
          sx={{ textTransform: "capitalize" }}
        >
          Export
        </Button>
      </Box>
       {holidayToggle && (
              <Dialog open={holidayToggle}>
                <DialogContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      padding: "1rem",
                      borderRadius: "0.2rem",
                      border: "1px solid grey",
                    }}
                  >
                    <WarningAmberRoundedIcon
                      sx={{ width: "5rem", height: "5rem", color: "#FF6D00" }}
                    />
                    <Typography
                      sx={{
                        fontSize: "1.5rem",
                        fontWeight: "bolder",
                      }}
                    >
                      Alert
                    </Typography>
                    <Typography sx={{ marginTop: "0.5rem" }}>
                      There is mandatory paid leave in this state{" "}
                      <span style={{ fontWeight: "bolder" }}>
                        {holidayDataToggle?.lookupLabel ?? ""}
                      </span>
                      . Please add{" "}
                      <span style={{ fontWeight: "bolder" }}>
                        {holidayDataToggle?.lookupVal ?? ""}{" "}
                      </span>
                      days in the vacation field
                    </Typography>
                    <Button
                      sx={{
                        width: "6rem",
                        marginTop: "1rem",
                        textTransform: "capitalize",
                      }}
                      variant="contained"
                      onClick={() => setHoliddayToggle(false)}
                    >
                      Ok
                    </Button>
                  </Box>
                </DialogContent>
              </Dialog>
            )}
    </Box>
  );
};

export default QuickCalcv2NoTransfer;
